import { render, staticRenderFns } from "./import-transport.vue?vue&type=template&id=2434b426&"
import script from "./import-transport.vue?vue&type=script&lang=ts&"
export * from "./import-transport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports